module.exports = __webpack_public_path__ + "static/images/dddf3f2e3e8e5003e7e7ed653a3fa6a3.png";